import { Component, Input, Output, EventEmitter, OnInit, ViewChildren, QueryList, ChangeDetectionStrategy } from '@angular/core';
import { faGift } from '@fortawesome/free-solid-svg-icons/faGift';
import { UntypedFormArray, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { getCurrencySymbol, NgClass, CurrencyPipe } from '@angular/common';

import { PaymentService } from 'src/app/services/payment.service';
import { VoucherComponent } from '../voucher/voucher.component';
import { NgxMaskDirective } from 'ngx-mask';
import { FontAwesomeModule, IconDefinition } from '@fortawesome/angular-fontawesome';
import { NgSelectComponent, NgOptionComponent } from '@ng-select/ng-select';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-basket',
    templateUrl: './basket.component.html',
    styleUrls: ['./basket.component.sass'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass, VoucherComponent, FormsModule, NgxMaskDirective, ReactiveFormsModule, FontAwesomeModule, NgSelectComponent, NgOptionComponent, CurrencyPipe, TranslatePipe]
})
export class BasketComponent implements OnInit {
    @ViewChildren('voucherEl') voucherRefs: QueryList<VoucherComponent>;

    @Output() deleted: EventEmitter<number> = new EventEmitter();
    @Output() added: EventEmitter<any> = new EventEmitter();
    @Output() pay: EventEmitter<void> = new EventEmitter();

    @Input() form: UntypedFormArray;
    @Input() company: any;
    @Input() totalVouchers = 0;
    @Input() totalWrapping = 0;
    @Input() totalDelivery = 0;
    @Input() totalExtras = 0;
    @Input() total = 0;
    @Input() totalPaid = 0;
    @Input() totalOwed = 0;
    @Input() brandId: string = '';
    @Input() promocode: string = '';
    @Input() affiliateId: string = '';

    public faGiftCard: IconDefinition = faGift;

    public confirmMissingPersonalization :boolean = false;
    public missingPersonalization :boolean = false;
    public ignoreMissingPersonalization :boolean = false;

    public amount = new UntypedFormControl(25);
    public currencies = ['GBP','EUR','USD','AUD','NZD','ZAR']

    public newCurrency: string;
    public showCurrency: boolean = false;

    public voucherAdded: boolean = false;
    public recVoucherAdded: boolean = false;

    public recVouchers: any[] = [];

    public exchangeRates: { [key: string] : number} = {
        GBP: 1,
        EUR: 1.2,
        USD: 1.4,
        AUD: 2,
        NZD: 2,
        ZAR: 20,
    }

    constructor(
        private payment: PaymentService
    ) { }

    ngOnInit() {
        //this.amount.disable();

        this.amount.setValue(this.company?.voucher_config?.displayValue || 25);

        this.newCurrency = this.company?.currency;

        this.recVouchers = [
            {   name: 'Clay Shooting Voucher', 
                desc: 'From first shot to flying clays, this voucher typically covers 25–30 clays with full instruction and all equipment provided.',
                price: Math.round((60 * (this.exchangeRates[this.newCurrency] || 1)) / 5) * 5,
                actId: '5',
                recId: 0,
                added: false,
            },
            {   name: 'Go Karting Voucher', 
                desc: 'Strap in for 30–60 minutes of high-speed fun, with all equipment and guidance included.',
                price: Math.round((40 * (this.exchangeRates[this.newCurrency] || 1)) / 5) * 5,
                actId: '2',
                recId: 1,
                added: false,
            },
            {   name: 'Paintball Voucher', 
                desc: 'Step into the combat zone - voucher typically covers paintball entry, full gear, and 300 paintballs at selected locations.',
                price: Math.round((30 * (this.exchangeRates[this.newCurrency] || 1)) / 5) * 5,
                actId: '1',
                recId: 2,
                added: false,
            },
            {   name: 'Quad Biking Voucher', 
                desc: 'Tackle rugged trails and off-road terrain with all equipment and instruction included—typically a 1-hour session.',
                price: Math.round((60 * (this.exchangeRates[this.newCurrency] || 1)) / 5) * 5,
                actId: '3',
                recId: 3,
                added: false,
            },
        ];
    }

    public get acceptPayments(): boolean {
        return this.payment.initialized;
    }

    public get currency(): string {
        return getCurrencySymbol(this.company?.currency || 'USD', 'narrow', 'en-GB');
    }

    public addVoucher(): void {
        this.added.emit({ value: this.amount.value, wrap_option_id: '3', mail_service_id: '1' });
        this.voucherAdded = true;
        setTimeout(() => {
            this.voucherAdded = false;
        }, 4000);
    }

    public addRecVoucher(value: number, actId: string, curr: string, recId: number): void {
        console.log('addRecVoucher called', value, actId, curr);
        let product_id = 'GV' + value + 'A' + actId + curr;
        console.log('Product_id is ', product_id);
        this.added.emit({ value: value, product_id: product_id, wrap_option_id: '3', mail_service_id: '1' });
        this.recVouchers[recId].added = true; 
        setTimeout(() => { 
            this.recVouchers[recId].added = false; 
        }, 4000);
    }

    public editVoucherValue(value: number): void {
        let amount = this.amount.value;
        if(this.newCurrency == 'ZAR' && this.company?.company_id == '2'){
            value = value*20;
            amount = Math.round(amount/100)*100;
        }
        const val = amount + value;

        if (val <= this.company?.voucher_config?.max && val >= this.company?.voucher_config?.min) this.amount.setValue(val);
    }

    public validate(): void {
        const invalid = this.voucherRefs.filter(item => {
            item.form.markAllAsTouched();

            return item.form.invalid;
        });

        if (invalid.length > 0) return;

        //check if 

        this.missingPersonalization = false;

        if(!this.ignoreMissingPersonalization){
            this.voucherRefs.forEach(it=>{
                let vals = it.form.getRawValue();
                if(!vals.message || !vals.name)
                    this.missingPersonalization = true;

            })
        }
        if(this.missingPersonalization) {
            if(!this.confirmMissingPersonalization) {
                this.confirmMissingPersonalization = true;
                return;
            }
        }

        this.pay.emit();
    }

    public changeCurrency(event): void{
        if(! event) return;
        let el : any= document.getElementsByTagName('geronigo-vouchers');
        if(el.length == 0){
            el = document.getElementsByTagName('rezbot-vouchers');
        }

        if(el.length > 0){
            console.log(el[0]);
            el[0].setCurrency =event
        }


    }
}
